// JQueryDateRange.jsx
import React, { useEffect, useRef } from "react";
import $ from "jquery";
import moment from "moment-timezone";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import "./JQueryDateRange.css";

const JQueryDateRange = ({ value, onChange, ranges }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const $input = $(inputRef.current);
    $input.daterangepicker(
      {
        timePicker: true,
        timePickerIncrement: 1,
        timePicker24Hour: true,
        startDate: moment(value[0]).tz("Asia/Baku"),
        endDate: moment(value[1]).tz("Asia/Baku"),
        locale: {
          format: "DD/MM/YYYY HH:mm",

          firstDay: 1,
          daysOfWeek: ["Pt", "Sa", "Ça", "Pe", "Cu", "Ct", "Pz"],
          monthNames: [
            "Oca",
            "Şub",
            "Mar",
            "Nis",
            "May",
            "Haz",
            "Tem",
            "Ağu",
            "Eyl",
            "Eki",
            "Kas",
            "Ara",
          ],
        },
        // ranges parametresi: daterangepicker’in beklediği formatta, moment nesneleri ile
        ranges: ranges.reduce((acc, item) => {
          acc[item.label] = [
            moment(item.value[0]).tz("Asia/Baku"),
            moment(item.value[1]).tz("Asia/Baku"),
          ];
          return acc;
        }, {}),
      },
      (start, end, label) => {
        onChange([start.toDate(), end.toDate()]);
      }
    );

    // Component unmount olduğunda temizle
    return () => {
      if ($input.data("daterangepicker")) {
        $input.data("daterangepicker").remove();
      }
    };
  }, [value, onChange, ranges]);

  return (
    <input
      type="text"
      ref={inputRef}
      style={{ width: "300px" }}
      className="jq-date-input"
    />
  );
};

export default JQueryDateRange;
